export default "__VITE_ASSET__71864c01__"